import { ReactComponent as ProfileScope } from './icon.svg'

export default ProfileScope
